import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Flex, LinkButton } from 'core/components';
import storeLoader from 'app/stores/storeLoader';
import { ReactComponent as ObservationDeckIcon } from 'app/assets/observation-deck-logo.svg';
import Deck from 'app/components/decks/Deck';
import SetupGauge from 'app/components/setup/SetupGauge';

/*
 * TODO: consider exposing this as a reusable component to avoid customize/boilerplate
 *
 * Deck itself is very flexible, but if we are going to usually have the same tools, we'll
 * want to avoid this getting replicated for every deck.
 */
@storeLoader('$setup.setupTasks')
@inject('$auth', '$devices', '$syn')
@observer
class ObservationDeck extends Component {
  get canCustomize() {
    const { $devices, $syn } = this.props;
    return $devices.activeDeviceSummaries.length > 0 || $syn.tests?.size;
  }

  render() {
    const { $auth, $setup } = this.props;
    const { canCustomize } = this;
    const pinnedBoardId = $auth.activeUser?.defaultLandingPageValue;

    return (
      <Deck
        title="Observation Deck"
        type="home"
        pinnedBoardId={pinnedBoardId}
        icon={ObservationDeckIcon}
        tools={
          <>
            {$auth.isAdministrator && canCustomize && $setup.setupTasks.size > 0 && (
              <Flex alignItems="center">
                <SetupGauge width={90} showLabel />
                <LinkButton text="View Setup Tasks" to="/v4/setup" />
              </Flex>
            )}
          </>
        }
        canCustomize={canCustomize}
        hideSetupGauge
        showOnboarding
        showLandingPageCallout
      />
    );
  }
}

export default ObservationDeck;
